"use strict";
/*
 * Created on 28. 4. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Configuration of opening promotion-related application subdomain.
 *
 * @author Radek Beran
 * @author Tomas Leity
 */


var OpeningAppConfig =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(OpeningAppConfig, _DomainObject_1$Domai);

  /**
   * @param enabled whether opening promotion feature is enabled
   * @param promotionTypeId default promotion type for opening promotions
   */
  function OpeningAppConfig(enabled, promotionTypeId) {
    var _this;

    _classCallCheck(this, OpeningAppConfig);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OpeningAppConfig).call(this));
    _this.enabled = enabled;
    _this.promotionTypeId = promotionTypeId;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(OpeningAppConfig, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new OpeningAppConfig(mat.enabled, mat.promotionTypeId);
    }
  }]);

  return OpeningAppConfig;
}(DomainObject_1.DomainObject);

exports.OpeningAppConfig = OpeningAppConfig;

OpeningAppConfig.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(OpeningAppConfig.name);
  return {
    enabled: builder.bool('enabled'),
    promotionTypeId: builder.str('promotionTypeId')
  };
}();